import React from "react";
import {
  Create,
  TextInput,
  SimpleForm,
  useNotify,
  useRefresh,
  useRedirect,
  choices,
  SelectInput,
  required,
} from "react-admin";

import { useCreateStyles } from "../__common/MyStyles";
import { MyCreateActions } from "../__common/MyCreateActions";
import { sleep } from "../../common/js/Functions";

export const StoragesCreate = (props) => {
  const classes = useCreateStyles();

  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = () => {
    notify(`Storage created`);
    sleep(2000).then(() => {
      redirect("/storages");
      refresh();
    });
  };

  const validateTypes = choices(
    ["Petri", "Tube", "Plate", "Other"],
    "Please choose one of the values"
  );

  return (
    <Create
      title="Create Storage"
      undoable={false}
      onSuccess={onSuccess}
      submitOnEnter={true}
      actions={<MyCreateActions />}
      classes={classes}
      {...props}
    >
      <SimpleForm>
        <TextInput source="storage" validate={required()} />
        <TextInput source="freezer" validate={required()} />
        <SelectInput
          label="Type"
          source="type"
          choices={[
            { id: "Petri", name: "Petri" },
            { id: "Tube", name: "Tube" },
            { id: "Plate", name: "Plate" },
            { id: "Other", name: "Other" },
          ]}
          validate={validateTypes}
        />
      </SimpleForm>
    </Create>
  );
};
